@if (nav(); as navigationData) {
  <boels-vertical-aligner [innerWidth]="'wide'">
    <nav aria-label="Main Menu" class="boels-navigation__nav">
      <ul class="boels-navigation__main-menu__list" role="menubar">
        @for (
          nav of navigationData?.navigationNode?.children;
          track nav;
          let i = $index
        ) {
          @if (nav.entries?.length && (!nav.children || !nav.pages)) {
            <li class="boels-navigation__main-menu__item" role="none">
              <a
                class="boels-navigation__main-menu__anchor -default"
                role="menuitem"
                (focus)="closeAllMenus()"
                [cmsRouterLink]="(nav.resolvedData | async)?.component?.url"
                boelsQa="main-menu-anchor"
              >
                {{ nav.title }}
              </a>
            </li>
          } @else {
            <li
              class="boels-navigation__main-menu__item -has-submenu"
              role="none"
              boelsDelayedHover
              (hoverEvent)="openSubmenu($event, 'hover')"
              [delay]="200"
              (mouseleave)="closeSubmenu($event, 'hover')"
            >
              <a
                class="boels-navigation__main-menu__anchor -has-submenu"
                [ngClass]="{ '-assortment': i === 0 }"
                role="menuitem"
                aria-haspopup="true"
                aria-expanded="false"
                (focus)="closeAllMenus()"
                (keydown.enter)="toggleSubmenu($event, 'click')"
                tabindex="0"
                boelsQa="main-menu-anchor"
              >
                {{ nav.title }}

                <fa-icon
                  size="xs"
                  class="boels-navigation__main-menu__anchor__chevron"
                  [icon]="faChevronDown"
                  aria-hidden="true"
                ></fa-icon>
              </a>
              @if (nav.children?.length || nav.pages?.pages?.length) {
                <div
                  class="boels-navigation__submenu__container"
                  role="menu"
                  aria-label="Submenu"
                  [ngClass]="{ '-assortment': i === 0, '-default': i !== 0 }"
                >
                  @if (i === 0) {
                    <ul class="boels-navigation__submenu__list" role="menu">
                      <h4>{{ navigationData.assortmentSubtitle }}</h4>
                      @for (children of nav.children; track children) {
                        <li
                          role="none"
                          tabindex="0"
                          class="boels-navigation__submenu__item -assortment -left"
                          [class.-active]="activeHoveredItem() === children"
                          boelsDelayedHover
                          (keydown.enter)="toggleChildSubmenu($event, children)"
                          (hoverEvent)="openChildSubmenu($event, children)"
                          (focus)="closeChildSubmenu()"
                          (keydown.tab)="goToChildSubmenuItem($event)"
                          (keydown.escape)="closeAllMenus()"
                          [delay]="200"
                          boelsQa="main-menu-anchor-submenu"
                        >
                          <span role="menuitem" aria-haspopup="true">
                            {{ children.title }}
                            <fa-icon
                              size="xs"
                              [icon]="faChevronRight"
                              aria-hidden="true"
                            ></fa-icon>
                          </span>
                        </li>
                      }
                    </ul>
                    <div
                      class="boels-navigation__submenu__children__container"
                      role="menu"
                      aria-label="Child submenu"
                    >
                      @if (nodeChildren()) {
                        @for (
                          child of nodeChildren()?.children;
                          let i = $index;
                          track child;
                          let lastChild = $last
                        ) {
                          @if (child.resolvedData | async; as resolvedData) {
                            <ul role="menu">
                              <a
                                class="boels-navigation__submenu__children__category-title"
                                role="menuitem"
                                (keydown)="handleChildSubmenuEvents($event, i)"
                                (click)="closeAllMenus()"
                                [cmsRouterLink]="resolvedData.category?.url"
                                boelsQa="main-menu-anchor-submenu-category-title"
                              >
                                <span>
                                  {{ resolvedData.category?.name }}
                                </span>
                              </a>
                              @for (
                                subCategory of resolvedData.category
                                  ?.subcategories;
                                let lastSubCategory = $last;
                                track subCategory
                              ) {
                                <li
                                  class="boels-navigation__submenu__children__item"
                                  role="none"
                                >
                                  <a
                                    [cmsRouterLink]="subCategory.url"
                                    role="menuitem"
                                    (keydown)="
                                      handleChildSubmenuEvents(
                                        $event,
                                        null,
                                        lastSubCategory && lastChild
                                      )
                                    "
                                    (click)="closeAllMenus()"
                                    (keydown.escape)="closeAllMenus()"
                                    boelsQa="main-menu-anchor-submenu-subCategory-title"
                                  >
                                    {{ subCategory.name }}
                                  </a>
                                </li>
                              }
                            </ul>
                          } @else {
                            <div
                              class="boels-navigation__submenu__children__loading"
                            >
                              <boels-skeleton
                                [inputHeight]="26"
                                [inputStyle]="{
                                  borderRadius: '4px',
                                  marginBottom: '32px',
                                }"
                              ></boels-skeleton>

                              @for (i of [1, 2, 3, 4]; track i) {
                                <boels-skeleton
                                  [inputHeight]="26"
                                  [inputStyle]="{ borderRadius: '4px' }"
                                ></boels-skeleton>
                              }
                            </div>
                          }
                        }
                      }
                    </div>
                  } @else if (nav.pages && nav.pages.pages.length) {
                    <boels-vertical-aligner [innerWidth]="'wide'">
                      <a
                        class="boels-navigation__submenu__category-title"
                        role="menuitem"
                        (keydown.escape)="closeAllMenus()"
                        [cmsRouterLink]="
                          (nav.resolvedData | async)?.component?.url
                        "
                      >
                        {{ nav.title }}
                      </a>
                      <ul class="boels-navigation__submenu__list" role="menu">
                        @for (page of nav.pages.pages; track page) {
                          <li
                            class="boels-navigation__submenu__children__item"
                            role="none"
                            boelsQa="main-menu-anchor-submenu-subCategory-item-title"
                          >
                            <a
                              [cmsRouterLink]="page.url"
                              role="menuitem"
                              (click)="closeAllMenus()"
                              (keydown.escape)="closeAllMenus()"
                            >
                              {{ page.title }}
                            </a>
                          </li>
                        }
                      </ul>
                    </boels-vertical-aligner>
                  }
                </div>
              }
            </li>
          }
        }
      </ul>
    </nav>
  </boels-vertical-aligner>
}
